/**
 * Created by mh on 2017/8/6.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import TimelineTableRowComponent from './TimelineTableRow';

@observer
class TimelineTable extends React.Component {
    render() {
        const { timelines } = this.props;

        return (
            <div className="table-responsive">
                <table className="table table-sm table-striped table-delivermedia">
                    <thead>
                        <tr>
                            <th>
                                <FormattedMessage id="Timelines.Layer" defaultMessage="Layer" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Block" defaultMessage="Block" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Name" defaultMessage="Name" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Actions" defaultMessage="Actions" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {timelines ?
                            timelines.map(timeline => (<TimelineTableRowComponent
                                timeline={timeline}
                                key={timeline.id} />))
                            : (
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            id="Timelines.NoTimelineFound"
                                            defaultMessage="No Timeline found" />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>);
    }
}

TimelineTable.propTypes = {
    timelines: PropTypes.object.isRequired,
};

export default injectIntl(TimelineTable);
